import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GarmentListingRoutes } from './features/garment-listing/garment-listing.routes';
import { CancelOrderRoutes } from './features/cancel-order/cancel-order-routes';
import { InvoiceRoutes } from './features/invoice/invoice.routes';
import { GRouteRoutes } from './features/g-route/g-route.routes';
import { LogSheetPage } from './features/g-route/pages/logsheet-page/logsheet.page';

const routes: Routes = [
  //Reports
  GarmentListingRoutes.Feature,
  CancelOrderRoutes.Feature,
  //Customer
  InvoiceRoutes.Feature,
  //Routing
  GRouteRoutes.Feature, 
  //Admin
  //View Order

  // TODO [EMP] Replace with a framework auth module
  {
    path: '',
    redirectTo: '/auth/route',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    redirectTo: 'auth/route',
    pathMatch: 'full',
  },
 
  {
    path: 'auth/route',
    loadChildren: () => import('./features/authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: 'auth/wearer',
    loadChildren: () => import('./features/authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: 'auth/mobile',
    loadChildren: () => import('./features/authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: 'auth/route',
    loadChildren: () => import('./features/authentication/authentication.module').then(m => m.AuthenticationModule)
  },


  // TODO [EMP] logout
 
  {
    path: '**',
    redirectTo: '/auth/route'
  },
  {
    
    path: 'logsheet',
    component: LogSheetPage,
    data: { breadcrumb: 'Logsheet' },
    children: [
      {
        path: 'stop/:id',
        component: LogSheetPage,
        data: { breadcrumb: 'stop' }
      }
    ]
  },
  
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // This value is required for server-side rendering to work.
      initialNavigation: 'enabled',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
